export const TRACKING_ICON_SLOTS = {
  destination: 'destination',
  driver: 'driver',
} as const;

export type TrackingIconSlot =
  (typeof TRACKING_ICON_SLOTS)[keyof typeof TRACKING_ICON_SLOTS];

export const TRACKING_ICON_ANCHORS = ['top', 'center', 'bottom'] as const;
export type TrackingIconAnchor = (typeof TRACKING_ICON_ANCHORS)[number];
export const DEFAULT_TRACKING_ICON_ANCHOR: TrackingIconAnchor = 'bottom';

export const TRACKING_ICON_ANCHOR_LABELS: Record<TrackingIconAnchor, string> = {
  top: 'Borde superior',
  center: 'Centro',
  bottom: 'Borde inferior (pin)',
};

export const TRACKING_ICON_ANCHOR_DESCRIPTIONS: Record<
  TrackingIconAnchor,
  string
> = {
  top: 'El centro del borde superior coincide con la ubicación. La imagen queda debajo del punto.',
  center: 'El centro de la imagen coincide con la ubicación.',
  bottom:
    'El centro del borde inferior coincide con la ubicación. La imagen queda encima del punto.',
};

export const getTrackingIconAnchor = (value: unknown): TrackingIconAnchor =>
  value === 'top' || value === 'center' ? value : DEFAULT_TRACKING_ICON_ANCHOR;

export interface TrackingIcon {
  id: string;
  slot: TrackingIconSlot;
  imageUrl?: string | null;
  anchor: TrackingIconAnchor;
  name: string;
  dateFrom: string | null;
  dateTo: string | null;
  enabled: boolean;
  isDefault: boolean;
  createdAt: string;
  updatedAt: string;
  createdById?: string | null;
  createdByName?: string | null;
  updatedById?: string | null;
  updatedByName?: string | null;
}

export interface CurrentTrackingIcon {
  id: string | null;
  slot: TrackingIconSlot;
  name: string;
  isDefault: boolean;
  imageUrl: string | null;
  anchor: TrackingIconAnchor;
  dateFrom: string | null;
  dateTo: string | null;
}

export interface TrackingIconFilter {
  name: string;
  enabled: string;
  isDefault: string;
}

export const TRACKING_ICON_INITIAL_FILTER: TrackingIconFilter = {
  name: '',
  enabled: '',
  isDefault: '',
};
